import { render } from "./EditUserModal.vue?vue&type=template&id=24784704&scoped=true"
import script from "./EditUserModal.vue?vue&type=script&lang=js"
export * from "./EditUserModal.vue?vue&type=script&lang=js"

import "./EditUserModal.vue?vue&type=style&index=0&id=24784704&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24784704"]])

export default __exports__